import { 
  collection, 
  addDoc, 
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  doc,
  updateDoc
} from 'firebase/firestore';
import { db } from './config';

// Save email only (step 1)
export const saveEmailOnly = async (email) => {
  try {
    const docRef = await addDoc(collection(db, 'betaSignups'), {
      email,
      emailSubmittedAt: serverTimestamp(),
      questionnaireCompleted: false,
      status: 'email-only'
    });
    return { success: true, signupId: docRef.id };
  } catch (error) {
    console.error('Error saving email:', error);
    return { success: false, error: error.message };
  }
};

// Update with questionnaire data (step 2)
export const updateWithQuestionnaire = async (signupId, questionnaireData) => {
  try {
    const signupRef = doc(db, 'betaSignups', signupId);
    await updateDoc(signupRef, {
      ...questionnaireData,
      questionnaireCompletedAt: serverTimestamp(),
      questionnaireCompleted: true,
      status: 'complete'
    });
    return { success: true };
  } catch (error) {
    console.error('Error updating questionnaire:', error);
    return { success: false, error: error.message };
  }
};

// Submit feedback only (no email)
export const submitFeedbackOnly = async (questionnaireData) => {
  try {
    await addDoc(collection(db, 'betaSignups'), {
      ...questionnaireData,
      email: 'no-email-provided',
      submittedAt: serverTimestamp(),
      questionnaireCompleted: true,
      status: 'feedback-only'
    });
    return { success: true };
  } catch (error) {
    console.error('Error submitting feedback:', error);
    return { success: false, error: error.message };
  }
};

// Submit complete beta signup (legacy - for if they complete everything)
export const submitBetaSignup = async (signupData) => {
  try {
    await addDoc(collection(db, 'betaSignups'), {
      ...signupData,
      submittedAt: serverTimestamp(),
      questionnaireCompleted: true,
      status: 'complete'
    });
    return { success: true };
  } catch (error) {
    console.error('Error submitting beta signup:', error);
    return { success: false, error: error.message };
  }
};

// Get all beta signups (for admin dashboard)
export const getAllBetaSignups = async () => {
  try {
    // Get all signups without ordering (since we have different timestamp fields)
    const snapshot = await getDocs(collection(db, 'betaSignups'));
    const signups = [];
    snapshot.forEach((doc) => {
      signups.push({ id: doc.id, ...doc.data() });
    });
    
    // Sort by the most recent timestamp (either emailSubmittedAt or submittedAt)
    signups.sort((a, b) => {
      const timeA = a.emailSubmittedAt || a.submittedAt || { seconds: 0 };
      const timeB = b.emailSubmittedAt || b.submittedAt || { seconds: 0 };
      return (timeB.seconds || 0) - (timeA.seconds || 0);
    });
    
    return signups;
  } catch (error) {
    console.error('Error getting beta signups:', error);
    return [];
  }
};
